import { Maybe } from "utils/maybe";

export const between = (min: number, max: number) => (value: Maybe<number>, label: string) => value.require(x => x >= min && x <= max, `${label} skal være mellem ${min}-${max}.`);
export const mapToInt = (value: Maybe<number>) => value.map(x => Math.floor(x));
export const requireInt = (value: Maybe<number>, label: string) => between(-2147483648, 2147483647)(value.require(x => Number.isInteger(x), `${label} skal være et heltal.`), label);
